import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Card} from 'antd';

import _ from 'lodash';

import * as actions from '../redux/actions/index';
import AreaChart from "../charts/AreaChart";

class CountyAreaCard extends Component {
  render() {
    const onClick = (year) => {
      this.props.actions.selectYear(year);
    };

    return (
      <Card className="StateComboCard" noHovering={true} loading={this.props.loading}>
        <h2 className="subtitle">
          {this.props.selectedCounty.name} County Selected Dimensions Over Time<br/>
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
          {this.props.xLabel} &nbsp;
          <small>vs</small> &nbsp;
          <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
          {this.props.yLabel}
        </h2>
        <AreaChart
          dimX={this.props.xField}
          dimY={this.props.yField}
          titleX={this.props.xLabel}
          titleY={this.props.yLabel}
          year={this.props.year}
          data={this.props.data}
          onClick={onClick}
        />
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  const countyFips = _.get(store, ['counties', 'selected', 'fips']);
  const countyData = _.get(store, ['counties', 'dict', countyFips], {});

  return {
    loading: store.counties.loading || store.dimensions.loading,
    selectedCounty: store.counties.selected,
    data: countyData,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(CountyAreaCard);



// WEBPACK FOOTER //
// ./src/containers/CountyAreaCard.js